import { render, staticRenderFns } from "./trainingTypeMaintenance.vue?vue&type=template&id=05234f9f"
import script from "./trainingTypeMaintenance.vue?vue&type=script&lang=js"
export * from "./trainingTypeMaintenance.vue?vue&type=script&lang=js"
import style0 from "./trainingTypeMaintenance.vue?vue&type=style&index=0&id=05234f9f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports